/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Kind_One_On_OneInputs */



/**
* | output |
* | --- |
* | "1:1" |
*
* @param {Meeting_Kind_One_On_OneInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_kind_one_on_one = /** @type {((inputs?: Meeting_Kind_One_On_OneInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Kind_One_On_OneInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("1:1")
	if (locale === "fr") return /** @type {LocalizedString} */ ("1:1")
	return /** @type {LocalizedString} */ ("1:1")
});